module.exports = __webpack_public_path__ + "media/videos/video-e549b490defccf7432ed97af0532297e.mov";